import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../services/authentication.service';

/*
 * <pre>
 * <b>Class name: JwtInterceptor</b>
 * <b>Explanation:</b> Interceptor service to pass token into http header
 * <b>Creation date:</b> 2019/08/25
 * </pre>
 *
 * @author GCS 2019/07/01 by linhdh
 **/
@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  /*
  * <pre>
  * <b>Method name: constructor</b>
  * <b>Explanation: </b> Method constructor
  * </pre>
  * @author GCS 2019/08/25 by linhdh
  *
  */
  constructor(private authenticationService: AuthenticationService) {
  }

  /*
  * <pre>
  * <b>Method name: intercept</b>
  * <b>Explanation: </b> Method intercept
  * </pre>
  * @author GCS 2019/08/25 by linhdh
  *
  */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add authorization header with jwt token if available
    // const currentUser = this.authenticationService.currentUserValue;
    const currentUser = localStorage.getItem('token') || sessionStorage.getItem('token');
    const lang = localStorage.getItem('__language') || 'vi';
    // if (currentUser && currentUser.data && currentUser.errorCode === 0 && currentUser.data.token) {
    if (currentUser) {
      // TODO: thêm authen cho api thì phải bỏ cái này đi
      if (request.url.endsWith("generate-image")) {
        request = request.clone({
          setHeaders: {
            'Accept-Language': lang
          }
        });
      }else{
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser}`,
            'Accept-Language': lang
          }
        });
      }
    } else {
      request = request.clone({
        withCredentials: true,
        setHeaders: {
          'Accept-Language': lang
        }
      });
    }

    return next.handle(request);
  }
}
